<template>
  <v-col>

    <v-menu
      v-model="rpcFilterMenu"
      :close-on-content-click="false"
      :nudge-width="240"
      :nudge-left="240"
      min-width="800"
      offset-y
      top
      >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template
            v-slot:activator="{ on: tooltip }"
          >
              <v-btn
                :icon="true"
                text
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-filter-cog-outline</v-icon>
              </v-btn>
          </template>
          <span>
            Nachrichtenfilter einstellen
            <b>Methoden</b>
            <ul v-if="activeMethodFilters.length > 0">
              <li v-for="(item, i) in activeMethodFilters" :key="i">
                {{ item }}
              </li>
            </ul>
            <b>Events</b>
            <ul v-if="activeEventFilters.length > 0">
              <li v-for="(item, i) in activeEventFilters" :key="i">
                {{ item }}
              </li>
            </ul>
          </span>
        </v-tooltip>
      </template>
  
      <v-card>
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="text-center display-1">
              Nachrichtenfilter
            </v-col>
          </v-row>
        </v-container>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-container fluid>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                RPC-Methode
                <TooltipBtn v-if="allRpcMethodsSelected"
                  icon="mdi-filter-remove"
                  @click="rpcMethodSelectNone"
                >
                  Ausgewählten Methoden aufheben
                </TooltipBtn>
                <TooltipBtn v-else
                  icon="mdi-filter-plus-outline"
                  @click="rpcMethodSelectAll"
                >
                  Alle Methoden auswählen
                </TooltipBtn>
              </v-col>
              <v-col
                cols="12"
                sm="8"
              >
                <v-select
                  v-model="activeMethodFilters"
                  :items="rpcMethodList"
                  :menu-props="{ maxHeight: '400' }"
                  label="Select"
                  multiple
                  hint="Anzuzeigende Methoden auswählen"
                  persistent-hint
                  @change="activeFiltersChanged"
                >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 5">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span
                    v-if="index === 5"
                    class="grey--text text-caption"
                  >
                    (+{{ activeMethodFilters.length - 1 }} ...weitere)
                  </span>
                </template>
                </v-select>
              </v-col>
              <v-col cols="2">
                RPC-Events
                <TooltipBtn v-if="allRpcEventsSelected"
                  icon="mdi-filter-remove"
                  @click="rpcEventSelectNone"
                >
                  Ausgewählten Methoden aufheben
                </TooltipBtn>
                <TooltipBtn v-else
                  icon="mdi-filter-plus-outline"
                  @click="rpcEventSelectAll"
                >
                  Alle Methoden auswählen
                </TooltipBtn>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="showEmptyEvents"
                  label="Events ohne Type anzeigen"
                  @change="activeFiltersChanged"
                ></v-checkbox>
              </v-col>
              <v-col cols="8">
                <v-select
                  v-model="activeEventFilters"
                  :items="rpcEventList"
                  :menu-props="{ maxHeight: '400' }"
                  label="Select"
                  multiple
                  hint="Anzuzeigende Events auswählen"
                  persistent-hint
                  @change="activeFiltersChanged"
                >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 5">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span
                    v-if="index === 5"
                    class="grey--text text-caption"
                  >
                    (+{{ activeEventFilters.length - 1 }} ...weitere)
                  </span>
                </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-menu>
    <TooltipBtn
      icon="mdi-filter-settings-outline"
      @click="resetFilter()"
    >
      Filter auf Werkseinstellung zurücksetzen
    </TooltipBtn>
    <TooltipBtn
      icon="mdi-filter-remove-outline"
      @click="deleteAllFilter()"
    >
      Alle Filter löschen
    </TooltipBtn>
  </v-col>
</template>

<script>
import TooltipBtn from '@/components/TooltipBtn.vue';

import { OnionRpcMethods, OnionRpcEvents } from '@/helpers/OnionRpc/OnionRpcMethods';

export default {
  props: [
    'value',
  ],
  emits: [
  ],
  data: () => ({
    rpcFilterMenu: false,
    activeMethodFilters: [],
    activeEventFilters: [],
    showEmptyEvents: false,
  }),
  components: {
    TooltipBtn,
  },

  computed: {
    rpcMethodList() {
      return OnionRpcMethods.map((x) => x.name);
    },
    allRpcMethodsSelected() {
      return this.activeMethodFilters.length === OnionRpcMethods.length;
    },
    rpcEventList() {
      return OnionRpcEvents.map((x) => x.shortName);
    },
    allRpcEventsSelected() {
      return this.activeEventFilters.length === OnionRpcEvents.length;
    },
  },

  methods: {
    rpcMethodSelectNone() {
      this.activeMethodFilters.splice(0);
    },
    rpcMethodSelectAll() {
      OnionRpcMethods.forEach((x) => {
        if (this.activeMethodFilters.indexOf(x.name) < 0) {
          this.activeMethodFilters.push(x.name);
        }
      });
    },
    rpcEventSelectNone() {
      this.activeEventFilters.splice(0);
    },
    rpcEventSelectAll() {
      OnionRpcEvents.forEach((x) => {
        if (this.activeEventFilters.indexOf(x.shortName) < 0) {
          this.activeEventFilters.push(x.shortName);
        }
      });
    },
    activeFiltersChanged() {
      const filter = {
        activeMethodFilters: this.activeMethodFilters,
        activeEventFilters: this.activeEventFilters,
        showEmptyEvents: this.showEmptyEvents,
      };
      this.$emit('input', filter);
    },
    deleteAllFilter() {
      this.activeMethodFilters.splice(0);
      this.activeEventFilters.splice(0);
      this.showEmptyEvents = false;
    },
    resetFilter() {
      const defaultHiddenMethods = [
      ];
      this.activeMethodFilters.push(...(OnionRpcMethods.map(
        (x) => defaultHiddenMethods.indexOf(x.shortName) >= 0 ? null : x.name,
      )).filter((x) => !!x));
      const defaultHiddenEvents = [
        'UART_RX',
      ];
      this.activeEventFilters.push(...(OnionRpcEvents.map(
        (x) => defaultHiddenEvents.indexOf(x.shortName) >= 0 ? null : x.shortName,
      )).filter((x) => !!x));
      this.showEmptyEvents = false;

      this.activeFiltersChanged();
    },
  },

  mounted() {
    // const { activeMethodFilters, activeEventFilters } = this.value;
    this.resetFilter();
  },

  watch: {
    // value(newValue) {
    //   this.activeMethodFilters.splice(0);
    //   this.activeEventFilters.splice(0);
    //   this.activeMethodFilters.push(newValue.activeMethodFilters);
    //   this.activeEventFilters.push(newValue.activeEventFilters);
    // }
  },
};
</script>

<style>

</style>